import hallClient from './HallClient';

class HallManager {
    async getHall(token) {
        return (await hallClient.getHall(token)).data;
    }

    getHallSvg(token) {
        return hallClient.getHallSvg(token);
    }

    async getTicketTypes(token) {
        return (await hallClient.getTicketTypesByEvent(token)).data;
    }

    async getSectors(token) {
        const { data: { items } } = await hallClient.getSectorsByEvent(token);
        const sectors = items.map((sector) => {
            const {
                sector_json: {
                    id,
                    compiled, transformation, label, shell,
                }, ...rest
            } = sector;

            return {
                ...rest, id, compiled, transformation, label, shell,
            };
        });

        return { items: sectors };
    }

    async getSector(token, hash) {
        const { data: { Row, ...rest } } = await hallClient.getSectorDetailsByEvent(token, hash);
        const { sector_json: sector } = rest;
        const rows = Object.values(Row.itemsById).filter(row => row.sector === sector.id);

        return {
            ...rest,
            id: sector.id,
            rows,
            compiled: sector.compiled,
            transformation: sector.transformation,
            label: sector.label,
            sector_json: sector,
        };
    }
}

export default new HallManager();
